import { startTransition, useEffect, useState } from 'react';

/**
 * Deferred first paint: false on the first (urgent) commit, true once a
 * transition lands. A page or view renders its cheap shell first and the
 * expensive body at transition priority, so navigating in opens instantly and
 * the body appears whole. Mount-scoped — it resets each time the caller mounts.
 */
export function useDeferredReady(): boolean {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    startTransition(() => setReady(true));
  }, []);
  return ready;
}
